import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesMaintenance} from '/redux/selector/remoteConfig.selector';

import MaintenancePage from './MaintenancePage';

export const MaintenancePageConnected = connect(
  createStructuredSelector({
    maintenance: variablesMaintenance,
  }),
)(MaintenancePage);
